import { Component, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { findFlagUrlByIso2Code } from 'country-flags-svg';


@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrl: './language-dropdown.component.css'
})
export class LanguageDropdownComponent {
  // Default 'flag' preserves every existing consumer's look unchanged
  // (login pages, staff layout, header-v2) — 'globe' is opt-in, used by
  // header-v3 to match its plain icon-only reference design instead of a
  // flag image inside a pill container.
  @Input() iconStyle: 'flag' | 'globe' = 'flag';

  showLanguageMenu = false;
  showConfirmModal = false;
  selectedLang: string | null = null;
  selectedLanguage: string | null = null;

  constructor(private translate: TranslateService) {}

  requestLanguageChange(lang: string) {
    this.selectedLang = lang;
this.selectedLanguage = lang === 'fr' ? 'Français' : lang === 'hi' ? 'हिन्दी' : 'English';
    this.showLanguageMenu = false;
    if (this.translate.currentLang != lang)
    this.showConfirmModal = true;
  }

  confirmLanguageChange() {
    if (this.selectedLang) {
      this.changeLanguage(this.selectedLang);
      this.selectedLang = null;
      this.showLanguageMenu = false;
    }
    this.showConfirmModal = false;
  }

  cancelLanguageChange() {
    this.selectedLang = null;
    this.showConfirmModal = false;
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  get currentLanguageLabel(): string {
    const lang = localStorage.getItem('lang') || 'en';
    return lang === 'fr' ? 'Français' : lang === 'hi' ? 'हिन्दी' : 'English';
  }

  toggleLanguageMenu() {
    this.showLanguageMenu = !this.showLanguageMenu;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    this.showLanguageMenu = false;
  }

  onDropdownClick(event: Event): void {
    event.stopPropagation();
  }

  getFlagUrl(code: string): string {
    return findFlagUrlByIso2Code(code);   
  }

  getFlagUrlByLang(langCode: string): string {
    const langToCountryMap: Record<string, string> = {
      English: 'gb',
      Français: 'fr',
      हिन्दी : 'in',
    };

    const countryCode = langToCountryMap[langCode] || 'gb';
    return findFlagUrlByIso2Code(countryCode.toUpperCase());
  }

}
